import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=45fd2400&scoped=true&"
import script from "./Authorized.ts?vue&type=script&lang=ts&"
export * from "./Authorized.ts?vue&type=script&lang=ts&"
import style0 from "./Authorized.css?vue&type=style&index=0&id=45fd2400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fd2400",
  null
  
)

export default component.exports